module.exports = __webpack_public_path__ + "img/index-hlw.16a75b8a.png";